import React, { ChangeEventHandler, FC } from 'react';

import { Input as AriaInput } from 'react-aria-components/Input';
import { useIntl } from 'react-intl';

import styles from './search.module.scss';

import { VoidFunctionNoArgs } from 'types';
import { Button } from 'views/components/UI/Button';
import { CloseSmall, SearchIcon } from 'views/components/UI/Icons/Icons';

interface ISearchProps {
  searchValue: string;
  handleSearch: ChangeEventHandler<HTMLInputElement>;
  handleClose?: VoidFunctionNoArgs;
}

const Search: FC<ISearchProps> = React.memo(props => {
  const { searchValue, handleSearch, handleClose } = props;
  const intl = useIntl();

  return (
    <div className={styles.search} role="search">
      <span className={styles.search__icon} aria-hidden="true">
        <SearchIcon />
      </span>
      <AriaInput
        className={styles.search__input}
        type="search"
        value={searchValue}
        placeholder={intl.formatMessage({ id: 'search.input.placeholder' })}
        onChange={handleSearch}
        aria-label={intl.formatMessage({ id: 'search.input.label' })}
        autoComplete="off"
        spellCheck={false}
      />
      {handleClose && (
        <Button
          className={styles.search__button}
          type="button"
          size="small"
          color="dark"
          icon={<CloseSmall />}
          onClick={handleClose}
          mode="tertiary"
          aria-label={intl.formatMessage({ id: 'search.button.clear' })}
        />
      )}
    </div>
  );
});

export { Search };
